import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Breadcrumb
} from 'antd';
import _ from 'lodash';

import styles from './TopNavigation.module.css';

const BreadcrumbItem = Breadcrumb.Item;
const pageLocation = (pathname) => _.trim(pathname, '/').split('/');

const TopNavigation = ({ location }) => {
  const { pathname } = location;
  const pageLocations = pageLocation(pathname).map(item => (
    {
      id: item,
      title: _.upperFirst(_.startCase(item))
    }
  ));
  const pageOptions = [
    { id: 'home', title: 'Home', to: '/reports/overview' },
    ...pageLocations,
  ];
  const breadcrumbItems = pageOptions.map((breadcrumb) => (
    breadcrumb.to ? (
      <BreadcrumbItem key={breadcrumb.id}><Link to={breadcrumb.to}>{breadcrumb.title}</Link></BreadcrumbItem>
    ) : (
      <BreadcrumbItem key={breadcrumb.id}>{breadcrumb.title}</BreadcrumbItem>
    )
  ));

  return (
    <div className={styles['top-navigation']}>
      <Breadcrumb>{breadcrumbItems}</Breadcrumb>
    </div>
  );
};

TopNavigation.propTypes = {
  location: PropTypes.object.isRequired,
};

export default TopNavigation;
